import { AssetTreeView } from '../../../types/app/assetTreeView.types';

/**
 * Rekurzivně projde strom assetů. Ke každému assetu doplní parent name.
 * Parent name má podobu např.: parent1/parent2/currentAsset
 * @param asset Aktuální asset
 * @param parentFullName Aktuální parentName
 * @returns
 */
export const generateParentNames = (asset: AssetTreeView, parentFullName: string) => {
  parentFullName = `${parentFullName}${parentFullName ? `/` : ''}${asset.name}`;
  let assetDescendants: any[] = [];
  if (asset.assetDescendants.length > 0) {
    assetDescendants = asset.assetDescendants.map((item) => {
      return generateParentNames(item, parentFullName);
    });
  }

  return {
    ...asset,
    parentFullname: parentFullName,
    assetDescendants: assetDescendants,
  };
};

/**
 * Rekurzivně projde strom assetů a vrátí jejich IDs. Pozor vrací
 * @param asset
 * @returns
 */
export const getDescendantsIds = (asset: AssetTreeView): number[] => {
  let ids: number[] = [asset.id];
  if (asset.assetDescendants.length > 0) {
    let descendantsIds: number[] = [];
    asset.assetDescendants.forEach((item: any) => {
      descendantsIds = [...descendantsIds, ...getDescendantsIds(item)];
    });
    ids = [...ids, ...descendantsIds];
  }

  return ids;
};

export const getDescendantsObject = (asset: AssetTreeView): AssetTreeView[] => {
  let assets: AssetTreeView[] = [asset];
  if (asset.assetDescendants.length > 0) {
    let descendants: AssetTreeView[] = [];
    asset.assetDescendants.forEach((item: AssetTreeView) => {
      descendants = [...descendants, ...getDescendantsObject(item)];
    });
    assets = [...assets, ...descendants];
  }

  return assets;
};
